import { render, staticRenderFns } from "./ExtendOtherNutrientsVitaminE.vue?vue&type=template&id=32001cbc&scoped=true"
import script from "./ExtendOtherNutrientsVitaminE.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsVitaminE.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsVitaminE.vue?vue&type=style&index=0&id=32001cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32001cbc",
  null
  
)

export default component.exports